import store from '@/store/index.js'
let dic = store.state.dic;
import {
    getOrgOptions,
} from "@/libs/searchSelect.js";
export default function Configs(that) {

    const searchItems = [
        {
            label: "学院",
            span: 6,
            type: 'select',
            model: "collegeId",
            options: dic._COLLEGE_OPTIONS,
            clearable: true,
            change(data) {
                that.searchItems[2].options = [];
                that.searchItems[3].options = [];
                that.pageParams.majorId = "";
                that.pageParams.classIdList = [];
                if (data) {
                    let params = {
                        parentId: data,
                        type: 'department',
                    }
                    getOrgOptions(that, params, 1, null);
                    params = {
                        parentId: data,
                        grade: that.pageParams.grade,
                        type: 'class'
                    }
                    that.searchItems[2].options = [];
                    that.pageParams.classIdList = [];
                    getOrgOptions(that, params, 3, null)
                }
            },
        },
        {
            label: "年级",
            span: 6,
            type: 'year',
            model: "grade",
            clearable: true,
            change(data) {
                that.searchItems[3].options = [];
                let parentId = "";
                if (that.pageParams.classIdList &&that.pageParams.classIdList.size>0) {
                    parentId = that.pageParams.classIdList.join(",");
                } else if (that.pageParams.majorId) {
                    parentId = that.pageParams.majorId;
                } else if (that.pageParams.collegeId) {
                    parentId = that.pageParams.collegeId;
                }
                let params = {
                    parentId: parentId,
                    grade: data,
                    type: 'class'
                }
                that.searchItems[3].options = [];
                that.pageParams.classIdList = [];
                getOrgOptions(that, params, 3, null)
            },
        },
        {
            label: "专业",
            span: 6,
            placeholder: '请选择专业',
            type: 'select',
            model: "majorId",
            clearable: true,
            options: [],
            change(data) {
                that.searchItems[3].options = [];
                that.pageParams.classIdList = [];
                let parentId = "";
                if (data) {
                    parentId = data;
                } else if (that.pageParams.collegeId) {
                    parentId = that.pageParams.collegeId;
                }
                let params = {
                    parentId: parentId,
                    grade: that.pageParams.grade,
                    type: 'class'
                }
                getOrgOptions(that, params, 3, null)
            },
        },
        {
            label: "班级",
            span: 6,
            placeholder: '请选择班级',
            type: 'select',
            model: "classIdList",
            multiple:true,
            clearable: true,
            options: [],
        },
        {
            label: "培养层次",
            span: 6,
            type: 'select',
            options:dic._DEGREE,
            model: "academicDegree",
            clearable: true,
        },
        {
            label: "学制",
            span: 6,
            type: 'select',
            options: dic._ACADEMICYEAR,
            model: "academicYear",
            clearable: true,
        },
        {
            label: "学号/姓名",
            prop: "studentNoOrName",
            span: 6,
            placeholder: '请输入',
            model: "studentNoOrName",
        },
        {
            label: "性别",
            span: 6,
            type: 'select',
            options: dic._SEXS,
            model: "sex",
            clearable: true,
        },
        // {
        //     label: "身份证号",
        //     span: 6,
        //     placeholder: '请输入身份证号',
        //     model: "idCard",
        // },
        // {
        //     label: "姓名",
        //     span: 6,
        //     placeholder: '请输入姓名',
        //     model: "studentName",
        // },
        {
            label: "预计交通方式",
            span: 6,
            placeholder: '请选择预计交通方式',
            model: "trafficType",
            labelWidth: '120px',
            type: "select",
            options: dic._TRANSPORT_OPTIONS
        },
        {
            label: "车次信息",
            span: 6,
            placeholder: '请输入车次信息',
            model: "trainInfo",
        },
        {
            label: "预计到校时间",
            span: 12,
            labelWidth: '120px',
            placeholder: '请选择预计到校时间',
            model: "timeRange",
            type: 'datetimerange'
        },
    ]
    const tableColumns = [
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            minWidth: 180,
            show: true
        },
        // {
        //     label: "系别",
        //     prop: "departmentName",
        //     align: "center",
        //     minWidth: 180,
        //     show: true
        // },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            minWidth: 260,
            show: true
        },
        {
            label: "班级",
            prop: "className",
            align: "center",
            minWidth: 160,
            show: true
        },
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
            minWidth: 140,
        },
        // {
        //     label: "身份证号",
        //     prop: "idCard",
        //     align: "center",
        //     show: true,
        //     minWidth: 180,
        // },
        {
            label: "姓名",
            prop: "name",
            align: "center",
            show: true
        },
        {
            label: "性别",
            prop: "sexName",
            align: "center",
            show: true
        },
        {
            label: "培养层次",
            prop: "academicDegreeName",
            align: "center",
            show: true
        },
        {
            label: "联系电话",
            prop: "contactPhone",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "预计到校时间",
            prop: "arriveSchoolTime",
            align: "center",
            minWidth: 200,
            show: true
        },
        // {
        //     label: "到站时间",
        //     prop: "arriveStationTime",
        //     align: "center",
        //     minWidth: 200,
        //     show: true
        // },
        {
            label: "预计交通方式",
            prop: "trafficType",
            align: "center",
            minWidth: 140,
            show: true
        },
        {
            label: "车次信息",
            prop: "trainInfo",
            align: "center",
            minWidth: 140,
            show: true
        },

        // {
        //     label: "乘车点",
        //     prop: "stationName",
        //     align: "center",
        //     minWidth: 140,
        //     show: true
        // },
        {
            label: "随从亲友",
            align: "center",
            name: 'status',
            minWidth: 100,
            show: true
        },
        {
            label: "操作",
            align: "center",
            name: 'custom',
            minWidth: 120,
            show: true
        },

    ]

    const dialogTableColumns = [{
        label: "随行亲友关系",
        prop: "relationship",
        align: "center",
        // width:'150px',
        show: true
    },
    {
        label: "亲友姓名",
        prop: "name",
        align: "center",
        // width:'150px',
        show: true
    },
    {
        label: "联系方式",
        prop: "contactPhone",
        align: "center",
        // width:'150px',
        show: true
    }]

    const desItems = [
        {
            label: "学号",
            model: "studentNo",
            span: 1,
        },
        {
            label: "身份证号",
            span: 1,
            model: "idCard",
        },
        {
            label: "姓名",
            span: 1,
            model: "name",
        },
        {
            label: "学院",
            span: 1,
            model: "collegeName",
        },
        {
            label: "专业",
            span: 1,
            model: "majorName",
        },
        {
            label: "预计到校日期",
            span: 1,
            model: "arriveSchoolTime",
        },
        {
            label: "预计到校时间",
            span: 1,
            model: "timeTypeName",
        },
        {
            label: "预计交通方式",
            span: 1,
            model: "trafficType",
        },
        {
            label: "车次信息",
            span: 1,
            model: "trainInfo",
        },
    ]

    return {
        searchItems,
        tableColumns,
        dialogTableColumns,
        desItems
    }
}
